import React, { useState } from "react";
import { Flex } from "rebass/styled-components";

import { AlertsContent, FeatureToggle, IconPack } from "../../../models/app-data-model";
import { sanitizeRichText } from "../../../services/string-manipulation/string-manipulation-service";
import ShIcon from "../../sh-icon/sh-icon";
import ShLink from "../../sh-link/sh-link";
import "./ch-alert.scss";

export type GlobalAlertProps = {
  alert: AlertsContent;
  index?: string;
  closeAlertCallback: (alert: AlertsContent) => void;
  iconPack: IconPack[];
  featureToggles: FeatureToggle[];
};

const ChAlert: React.FC<GlobalAlertProps> = ({ alert, index, closeAlertCallback, iconPack, featureToggles }: GlobalAlertProps) => {
  const [showAlert, setShowAlert] = useState(true);

  const alertClass = alert.alert.type?.toLocaleLowerCase();

  const isDismissible = alert.alert?.dismissible ? "is-dismissible" : "";

  const closeAlert = (): void => {
    setShowAlert(false);
    closeAlertCallback(alert);
  };

  return showAlert ? (
    <Flex className={`ch-alert ${alertClass} ${isDismissible}`} key={`ch-${index}`} role="alert">
      <Flex className="ch-alert-col ch-alert-icon-container">
        <ShIcon className="ch-alert-icon" iconPack={iconPack} iconName={alert.alert.type === "Negative" ? "white_warning" : "info"} />
      </Flex>
      <Flex className="ch-alert-col ch-alert-body-container">
        <Flex className="ch-alert-headline">
          <div className={`ch-alert-headline-text ${alertClass} ${isDismissible} `}>{alert.alert.headline}</div>
        </Flex>
        <div
          className={`ch-alert-body ${alertClass} ${isDismissible}`}
          dangerouslySetInnerHTML={{ __html: sanitizeRichText(alert.alert.body) }}
        ></div>
        <div className="ch-alert-links">
          {alert.primary_button?.text && (
            <ShLink
              className={`ch-alert-link ${alertClass}`}
              title={alert.primary_button?.text}
              reference={alert.primary_button?.reference}
              onClick={alert.primary_button?.onClick}
              featureToggles={featureToggles}
              iconPack={iconPack}
            />
          )}
          {alert.secondary_button?.text && (
            <ShLink
              className={`ch-alert-link ${alertClass}`}
              title={alert.secondary_button?.text}
              reference={alert.secondary_button?.reference}
              onClick={alert.secondary_button?.onClick}
              featureToggles={featureToggles}
              iconPack={iconPack}
            />
          )}
        </div>
      </Flex>
      {!alert.alert.dismissible && (
        <div className="ch-alert-col ch-alert-close-btn-container">
          <button data-testid="close-btn" className={`ch-alert-close-btn unstyled-btn ${alertClass}`} onClick={() => closeAlert()}>
            <ShIcon iconPack={iconPack} iconName={alertClass === "negative" ? "white_close" : "close"} className="close-btn-icon" />
          </button>
        </div>
      )}
    </Flex>
  ) : null;
};

export default ChAlert;
